import { useNavigate } from "react-router-dom";
import ActionMenu, {
  ActionMenuItem,
} from "../../../../../components/actionMenu/ActionMenu";
import { expeditionRoutes } from "../../../../../router/routesConstants";
import { useAppDispatch } from "../../../../../redux/hooks";
import usePermissions from "../../../../../router/usePermissions";
import userRoles from "../../../../../constants/userRoles";
import { ClientDataInterface } from "../../../../../redux/interfaces/expedition.interface";
import { postSetClientStatus } from "../../../../../redux/api/expedition.api";
import withPackagesDeliveredReportModal from "../hoc/withPackagesDeliveredReportModal";

function ClientsActionButton({
  itemId,
  crudData,
  showPackagesDeliveryModal,
}: {
  itemId: string;
  crudData: ClientDataInterface;
  showPackagesDeliveryModal: ({
    idClient,
    denumireClient,
  }: {
    idClient: string;
    denumireClient: string;
  }) => void;
}) {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { isAuthorized } = usePermissions();

  const { CLIENTS_WORKING_POINTS_PERMISSION, CLIENT_DATA_EDIT } = {
    CLIENTS_WORKING_POINTS_PERMISSION: isAuthorized(
      userRoles.CLIENTS_WORKING_POINTS,
    ),

    CLIENT_DATA_EDIT: isAuthorized(userRoles.CLIENT_DATA_EDIT),
  };

  const handleGoToClientWorkingPoints = () => {
    navigate(
      `${itemId}/${expeditionRoutes.clientsWorkingPoints}?denumireClient=${crudData.denumireClient}`,
    );
  };

  const handleEditClient = () => {
    navigate(`${itemId}`);
  };

  const handleGoToClientAwbHistory = () => {
    navigate(
      `/${expeditionRoutes.clients}/${itemId}/${expeditionRoutes.clientAwbHistory}`,
    );
  };

  const handleGoToClientUndeliveredAwb = () => {
    navigate(
      `/${expeditionRoutes.clients}/${itemId}/${expeditionRoutes.undeliveredAwb}`,
    );
  };

  const handleChangeClientStatus = () => {
    dispatch(
      postSetClientStatus({
        idClient: itemId,
        status: crudData.status ? 0 : 1,
      }),
    );
  };

  const handleShowPackagesDeliveredReportModal = () => {
    showPackagesDeliveryModal({
      idClient: itemId,
      denumireClient: crudData.denumireClient,
    });
  };

  const items: ActionMenuItem[] = [
    {
      id: "edit",
      label: "Editeaza clientul",
      icon: "EDIT",
      section: "manage",
      tooltip: "Deschide editarea datelor clientului.",
      hidden: !CLIENT_DATA_EDIT,
      onClick: handleEditClient,
    },
    {
      id: "awb-history",
      label: "Expeditii client",
      icon: "DELIVERED_AWB",
      section: "browse",
      tooltip: "Afiseaza istoricul expeditiilor acestui client.",
      onClick: handleGoToClientAwbHistory,
    },
    {
      id: "undelivered",
      label: "Comenzi nefinalizate",
      icon: "UNDELIVERED_AWB",
      section: "browse",
      tooltip: "Afiseaza comenzile nefinalizate ale acestui client.",
      onClick: handleGoToClientUndeliveredAwb,
    },
    {
      id: "working-points",
      label: "Puncte de livrare",
      icon: "WORKING_POINT",
      section: "browse",
      tooltip: "Afiseaza punctele de livrare ale clientului.",
      hidden: !CLIENTS_WORKING_POINTS_PERMISSION,
      onClick: handleGoToClientWorkingPoints,
    },
    {
      id: "delivery-report",
      label: "Raport colete livrare",
      icon: "SUMMARIZE",
      section: "browse",
      tooltip: "Deschide raportul coletelor livrate pentru acest client.",
      onClick: handleShowPackagesDeliveredReportModal,
    },
    {
      id: "change-status",
      label: crudData.status ? "Invalideaza client" : "Valideaza client",
      icon: "CHECKBOX",
      section: "danger",
      color: crudData.status ? "error" : "success",
      hidden: !CLIENT_DATA_EDIT,
      tooltip: crudData.status
        ? "Invalideaza acest client, dupa confirmare."
        : "Valideaza acest client, dupa confirmare.",
      withConfirmationModal: {
        modalTitle: "Modificare stare client",
        modalSubtitle: `Doriti sa ${
          crudData.status ? "invalidati" : "validati"
        } clientul ${crudData.denumireClient}?`,
        modalLeftButtonVariant: "outlined",
        modalRightButtonOnClick: handleChangeClientStatus,
      },
    },
  ];

  return (
    <ActionMenu
      items={items}
      title={crudData.denumireClient}
      ariaLabel={`Actiuni pentru clientul ${crudData.denumireClient}`}
    />
  );
}

export default withPackagesDeliveredReportModal(ClientsActionButton);
